import React, { useState, useEffect } from "react";
import { Link } from "react-router-dom";
import {
  Box,
  Container,
  CssBaseline,
  Grid,
  ThemeProvider,
  Typography,
  styled,
  useMediaQuery,
} from "@mui/material";
import theme from "../../../config/theme";
import { Circle } from "@mui/icons-material";
import { StyledButton } from "../../../components/common/Button";
import quotation from "../../../assets/quotation.png";
import rgit from "../../../assets/rgit.png";

const Item = styled("div")({
  alignItems: "center",
});

const gridData = [
  {
    name: "RGIT",
    link: "https://www.rgit.co.in",
    imgSrc: rgit,
  },
];

const steps = [
  {
    label: "- Dr. Priya Sharma",
    description:
      "Youstad has transformed our college operations. The integrated platform has streamlined our financial management and student services.",
    designation: "Principal, DIT",
  },
  {
    label: "- Rajesh Kumar",
    description: "The analytics dashboard provides incredible insights into our institution's performance. We can now make data-driven decisions.",
    designation: "Director, Mumbai Tech",
  },
  {
    label: "- Prof. Anjali Patel",
    description:
      "Managing our canteen operations has never been easier. The Bite module has transformed our food services significantly.",
    designation: "Admin, Bangalore University",
  },
];

const Client = () => {
  const [activeStep, setActiveStep] = useState(0);
  const maxSteps = steps.length;
  const handleStepChange = (step) => {
    setActiveStep(step);
  };
  useEffect(() => {
    const autoplayTimer = setInterval(() => {
      setActiveStep((prevStep) => (prevStep + 1) % maxSteps);
    }, 10000);

    return () => {
      clearInterval(autoplayTimer);
    };
  }, [maxSteps]);
  const calculateGridSize = () => {
    const numLogos = gridData.length;
    return Math.floor(12 / numLogos);
  };

  const isMobile = useMediaQuery(theme.breakpoints.down("sm"));

  return (
    <ThemeProvider theme={theme}>
      <CssBaseline />
      <Container maxWidth={false}>
        <Box sx={{ marginTop: ["3.75rem", "7.5rem"] }}>
          <Typography
            variant="h3"
            sx={{
              fontWeight: 700,
              fontSize: ["1.375rem", "2.75rem"],
              textAlign: "center",
              color: "#212121",
            }}
          >
            Our Valued Clients and Partners
          </Typography>
        </Box>
        <Box sx={{ marginTop: ["2.5rem", "3.75rem"] }}>
          <Grid container spacing={2}>
            {gridData.map((item, index) => (
              <Grid item xs={calculateGridSize()} key={index}>
                <Item>
                  <Box sx={{ display: "flex", justifyContent: "center" }}>
                    <Link to={item.link} target="_blank">
                      <img
                        style={{ height: "7.5rem" }}
                        src={item.imgSrc}
                        alt={item.name}
                      />
                    </Link>
                  </Box>
                </Item>
              </Grid>
            ))}
          </Grid>
        </Box>
        <Box
          sx={{
            display: "flex",
            marginTop: ["2.5rem", "3.75rem"],
            minHeight: ["12rem", "18rem"],
            overflow: "visible",
            alignItems: "center",
            justifyContent: "center",
            flexWrap: "wrap",
            gap: ["1rem", "2rem"],
          }}
        >
          <Box
            sx={{
              border: [
                "0.127066px solid #5865F2",
                "0.285938px solid rgba(88, 101, 242, 0.2)",
              ],
              borderRadius: ["0.23824875rem", "0.5rem"],
              background: ["#FFFFFF", "rgba(255, 255, 255, 0.2)"],
              width: ["8rem", "22.875rem"],
              minHeight: ["9rem", "13rem"],
              padding: ["0.5rem", "1rem"],
              boxShadow: [
                "0px 2.54132px 7.62396px rgba(88, 101, 242, 0.15)",
                "none",
              ],
              display: "flex",
              alignItems: "center",
              justifyContent: "center",
            }}
          >
            <Typography
              sx={{
                fontWeight: [700, 400],
                fontSize: ["0.385541875rem", "0.825rem"],
                textAlign: "center",
                letterSpacing: ["0.0029781125rem", "0.0067016875rem"],
                color: ["#212121", "rgba(33, 33, 33, 0.2)"],
                width: "100%",
                marginTop: ["0.96375rem", "1.429375rem"],
              }}
            >
              {steps[(activeStep + 2) % maxSteps].description}
            </Typography>
          </Box>
          <Box
            sx={{
              height: "100%",
              display: "flex",
              marginLeft: ["-1.5rem", "2.5625rem"],
            }}
          >
            <Box
              sx={{
                display: "flex",
                height: ["1.125rem", "3.5rem"],
              }}
            >
              <img src={quotation} alt="" />
              <Box
                sx={{
                  display: "flex",
                  alignItems: "center",
                  flexDirection: "column",
                  border: [" 0.164789px solid #5865F2", "0.4px solid #5865F2"],
                  borderRadius: ["0.30897875rem", "0.75rem"],
                  boxShadow: "0px 8px 24px rgba(88, 101, 242, 0.15)",
                  width: ["12rem", "36rem"],
                  minHeight: ["12rem", "18rem"],
                  padding: ["1rem", "2rem"],
                  color: "#212121",
                }}
              >
                <Box
                  sx={{
                    marginTop: ["1.25rem", "2rem"],
                  }}
                >
                  <Typography
                    sx={{
                      lineHeight: ["0.75rem", "1.5rem"],
                      fontSize: ["0.5rem", "1.125rem"],
                      fontWeight: 700,
                      letterSpacing: ["0.0038622375rem", "0.01rem"],
                      textAlign: "center",
                      width: "100%",
                    }}
                  >
                    {steps[activeStep].description}
                  </Typography>
                </Box>
                <Box
                  sx={{
                    marginTop: ["1.25rem", "2rem"],
                  }}
                >
                  <Typography
                    sx={{
                      //width: ["2.25rem", "4.6875rem"],
                      fontSize: ["0.625rem", "1.375rem"],
                      fontWeight: 400,
                    }}
                  >
                    {steps[activeStep].label}
                  </Typography>
                </Box>
                <Box
                  sx={{
                    marginTop: ["0.25rem", "0.5rem"],
                    marginBottom: ["1.25rem", "2rem"],
                  }}
                >
                  <Typography
                    sx={{
                      fontSize: ["0.4rem", "0.9rem"],
                      fontWeight: 400,
                      letterSpacing: ["0.0038622375rem", "0.01rem"],
                      textAlign: "center",
                      width: "100%",
                    }}
                  >
                    {steps[activeStep].designation}
                  </Typography>
                </Box>
              </Box>
            </Box>
          </Box>
          <Box
            sx={{
              border: [
                "0.127066px solid #5865F2",
                "0.285938px solid rgba(88, 101, 242, 0.2)",
              ],
              borderRadius: ["0.23824875rem", "0.5rem"],
              background: ["#FFFFFF", "rgba(255, 255, 255, 0.2)"],
              width: ["8rem", "22.875rem"],
              minHeight: ["9rem", "13rem"],
              padding: ["0.5rem", "1rem"],
              boxShadow: [
                "0px 2.54132px 7.62396px rgba(88, 101, 242, 0.15)",
                "none",
              ],
              display: "flex",
              alignItems: "center",
              justifyContent: "center",
            }}
          >
            <Typography
              sx={{
                fontWeight: [700, 400],
                fontSize: ["0.385541875rem", "0.825rem"],
                textAlign: "center",
                letterSpacing: ["0.0029781125rem", "0.0067016875rem"],
                color: ["#212121", "rgba(33, 33, 33, 0.2)"],
                width: "100%",
                marginTop: ["0.96375rem", "1.429375rem"],
              }}
            >
              {steps[(activeStep + 2) % maxSteps].description}
            </Typography>
          </Box>
        </Box>
        <Box
          sx={{
            marginTop: ["1.25rem", "2rem"],
            display: "flex",
            justifyContent: "center",
            gap: ["0.351875rem", "0.75rem"],
          }}
        >
          {[...Array(maxSteps)].map((_, i) => (
            <Circle
              key={i}
              onClick={() => handleStepChange(i)}
              style={{
                color: activeStep === i ? theme.palette.primary.main : "white",
                backgroundColor:
                  activeStep === i ? theme.palette.primary.main : "white",
                border: `1px solid ${theme.palette.primary.main}`,
                borderRadius: "50%",
                height: isMobile ? "0.625rem" : "1.25rem",
                width: isMobile ? "0.625rem" : "1.25rem",
                cursor: "pointer",
              }}
            />
          ))}
        </Box>
        <Box sx={{ marginTop: ["3.75rem", "12.125rem"] }}>
          <Typography
            variant="h3"
            sx={{
              textAlign: "center",
              fontWeight: 700,
              fontSize: ["1rem", "2.75rem"],
              color: "#212121",
              whiteSpace: "nowrap",
            }}
          >
            Unlock the power of organization
          </Typography>
        </Box>
        <Box sx={{ marginTop: ["0.5rem", "2rem"] }}>
          <Typography
            variant="h6"
            sx={{
              fontSize: ["0.75rem", "1.125rem"],
              fontWeight: 400,
              color: "#212121",
              letterSpacing: ["0.0079055rem", "0.01rem"],
              textAlign: "center",
            }}
          >
            Experience the Transformational Power of Our Educational Platform
          </Typography>
        </Box>
        <Box
          sx={{
            display: "flex",
            justifyContent: "center",
            marginTop: ["1.25rem", "3rem"],
            marginBottom: ["3.75rem", "4.25rem"],
          }}
        >
          {isMobile ? (
            <StyledButton
              variant="contained"
              sx={{ 
                height: "1.5rem",
                width: "10.375rem",
                backgroundColor: theme.palette.primary.main 
              }}
            >
              <Typography sx={{ fontSize: "0.5rem", fontWeight: 700 }}>
                SIGN UP NOW
              </Typography>
            </StyledButton>
          ) : (
            <StyledButton
              variant="contained"
              sx={{ 
                height: "3rem",
                width: "11.6875rem",
                backgroundColor: theme.palette.primary.main 
              }}
            >
              SIGN UP NOW
            </StyledButton>
          )}
        </Box>
      </Container>
    </ThemeProvider>
  );
};

export default Client;
